"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProdutoServico = void 0;
const typeorm_1 = require("typeorm");
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
let ProdutoServico = class ProdutoServico extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdProdutoServico = void (0);
        this.cdCategoriaEconomica = void (0);
        this.nmProdutoServico = void (0);
        this.txtProdutoServico = void (0);
        this.txtEspecificacao = void (0);
        this.txtDadoTecnico = void (0);
        this.txtPrazoEntrega = void (0);
        this.tpProdutoServico = void (0);
        this.idProdutoServico = void (0);
        this.sgProdutoServico = void (0);
        this.cdClassificacaoFiscal = void (0);
        this.cdFabricante = void (0);
        this.cdMarca = void (0);
        this.nmModelo = void (0);
        this.cdNcm = void (0);
        this.nrReferencia = void (0);
        this.cdCategoriaReceita = void (0);
        this.cdCategoriaDespesa = void (0);
        this.vlServico = void (0);
        this.lgReembolsavel = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_produto_servico", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "cdProdutoServico", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_categoria_economica", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "cdCategoriaEconomica", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_produto_servico", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "nmProdutoServico", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "txt_produto_servico", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "txtProdutoServico", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "txt_especificacao", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "txtEspecificacao", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "txt_dado_tecnico", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "txtDadoTecnico", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "txt_prazo_entrega", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "txtPrazoEntrega", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "tp_produto_servico", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "tpProdutoServico", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "id_produto_servico", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "idProdutoServico", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "sg_produto_servico", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "sgProdutoServico", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_classificacao_fiscal", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "cdClassificacaoFiscal", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_fabricante", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "cdFabricante", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_marca", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "cdMarca", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_modelo", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "nmModelo", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_ncm", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "cdNcm", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_referencia", nullable: true }),
    __metadata("design:type", String)
], ProdutoServico.prototype, "nrReferencia", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_categoria_receita", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "cdCategoriaReceita", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_categoria_despesa", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "cdCategoriaDespesa", void 0);
__decorate([
    typeorm_1.Column("double precision", { name: "vl_servico", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "vlServico", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_reembolsavel", nullable: true }),
    __metadata("design:type", Number)
], ProdutoServico.prototype, "lgReembolsavel", void 0);
ProdutoServico = __decorate([
    typeorm_1.Entity('grl_produto_servico')
], ProdutoServico);
exports.ProdutoServico = ProdutoServico;
